module.exports = __webpack_public_path__ + "media/images/common-nav/state-parks/oregon-87ce2027893210b1eefeced369b3bdaf.jpg";